import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { UserAboutData, UserPreferencesData } from '@/api/users/userAbout';

interface UserAboutState {
  userAboutData: UserAboutData | null;
  userPreferences: UserPreferencesData | null;
}

const initialState: UserAboutState = {
  userAboutData: null,
  userPreferences: null,
};

const userAboutSlice = createSlice({
  name: 'userAbout',
  initialState: initialState,
  reducers: {
    setUserAboutData: (state, action: PayloadAction<UserAboutData | null>) => {
      state.userAboutData = action.payload;
    },
    setUserPreferences: (state, action: PayloadAction<UserPreferencesData | null>) => {
      state.userPreferences = action.payload;
    },
  },
});

export const { setUserAboutData, setUserPreferences } = userAboutSlice.actions;

export const selectUserAboutData = (state: RootState) => {
  return state.userAbout.userAboutData;
};

export const selectUserPreferences = (state: RootState) => {
  return state.userAbout.userPreferences;
};

export const userAboutReducer = userAboutSlice.reducer;
